import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function AdminLogin() {
    const { login, user } = useAuth();
    const nav = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    if (user) { nav("/admin", { replace: true }); return null; }

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await login(email, password);
            toast.success("Accesso effettuato");
            nav("/admin");
        } catch (err) {
            toast.error(formatApiError(err));
        } finally { setLoading(false); }
    };

    return (
        <div className="min-h-screen bg-white flex items-center justify-center p-4">
            <div className="w-full max-w-sm">
                <h1 className="text-2xl font-bold text-gray-900 text-center mb-1">MAX AGENDA</h1>
                <p className="text-sm text-gray-500 text-center mb-6">Area riservata</p>
                <form onSubmit={submit} className="border border-gray-200 p-5 space-y-4">
                    <div>
                        <Label htmlFor="e">Email</Label>
                        <Input id="e" type="email" required value={email} onChange={(x) => setEmail(x.target.value)} data-testid="login-email" />
                    </div>
                    <div>
                        <Label htmlFor="p">Password</Label>
                        <Input id="p" type="password" required value={password} onChange={(x) => setPassword(x.target.value)} data-testid="login-password" />
                    </div>
                    <Button type="submit" disabled={loading} className="w-full bg-green-700 hover:bg-green-800 text-white" data-testid="login-submit">
                        {loading ? "Accesso…" : "ACCEDI"}
                    </Button>
                </form>
                <div className="mt-4 text-center">
                    <a href="/" className="text-xs text-gray-400 hover:text-gray-600">Torna all'agenda pubblica</a>
                </div>
            </div>
        </div>
    );
}
